module.exports = __webpack_public_path__ + "static/media/modern-building.0d653139.jpg";